export const getMediaDevices = async t => {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    const deviceCounts = {
      audioinput: 0,
      videoinput: 0,
      audiooutput: 0,
    };
    devices.forEach(device => {
      if (device.kind === "audioinput") {
        deviceCounts.audioinput++;
      } else if (device.kind === "videoinput") {
        deviceCounts.videoinput++;
      } else if (device.kind === "audiooutput") {
        deviceCounts.audiooutput++;
      }
    });

    return [
      `${deviceCounts.audioinput} ${t("scannerFingerprint.mediaDevices.audioinput")}`,
      `${deviceCounts.videoinput} ${t("scannerFingerprint.mediaDevices.videoinput")}`,
      `${deviceCounts.audiooutput} ${t("scannerFingerprint.mediaDevices.audiooutput")}`,
    ];
  } catch {
    return [t("global.notSupported")];
  }
};
